import "../SideDrawer/menuItem.css";
import "./fileToolbar.scss";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { runInnerFunction } from "../compatManager";
import { RightMenuItemPropType, SaveButtonProps } from "./fileToolbarTypes";
import { NavObjectType, lddGlobalSessionInfo } from "../Components/navigationTypes";
import { CONST } from "../SideDrawer/sideTypes";
import { RightSideContext } from "../Components/Home/home";
import { NavigationContext } from "../Context/NavigationContext";
import { ReducerEnum, lddStateObject, setListDataState, setIndicators, setShowPackageSaveWarning } from "../redux/reducer";
import { RootState, store } from "../redux/store";
import { useAppSelector } from "../redux/hooks";
import KeyDate from "../Components/taskSystem/KeyDate";
import { getDataReader, RPWDataReader} from "../livedataFuncs";
import { ActivityCenterContext, ActivityCenterContextType } from "../Context/ActivityCenter";
import { OpenReports } from "../Components/topbars/TopBar";
import DriveTab from "../Components/FileDrive/FileDriveTab";
import { isPageInDR } from "../dr/Components/drFuncs"
import { updatePackageList } from "../Components/DocMasters/PackagesFuncs";
import axios from "axios";

export type IndicatorBadgeType = {
    type: string,
    label: string,
}

enum ScreenType {
    InFile = "purfileedit",
    FirmSettings = "EditUserProfile",
    Packages = "packages",
}



function saveFile(activityCenterAdd: ActivityCenterContextType["Add"]): string {
    var retVal: string = runInnerFunction('SaveFile', true);
    if (retVal > "" && retVal.replace(/\s/g, '')) {
        activityCenterAdd(retVal, undefined, 'save', undefined);
    }
    return retVal;
}


export function triggerSaveButtonClick(): void {
    // Get the necessary data from the Redux store
    const state = store.getState();
    const keyDateTasks = state.InFileTasks;
    const livedataRootContainer = state.currentNavigation.livedataRootContainer;
    const SESSION_INFO = state.SessionInfo;
    
    // Call SaveKeyDates directly
    if (livedataRootContainer && livedataRootContainer.dataRoot) {
        KeyDate.SaveKeyDates(getDataReader(livedataRootContainer.dataRoot), SESSION_INFO, keyDateTasks);
    }
}

const OpenBCRegistration: NavObjectType = { component: "main", url: "registrationFrame.asp", popup: true, popupStyle: "xlarge", isModal: true, params: { "compat": "1", "openFromMain": "1", 'NoHeader': '1' } };
const OpenBCTitleSearch: NavObjectType = { component: "main", url: "lfmaster.asp", popup: true, popupStyle: "xlarge", isModal: true, params: { "compat": "1", "formxml": "TitleSearchTDV4", "src": "NewLiveFormapp.asp", 'NoHeader': '1' } };

export const saveEsignFields = async (msgID: string, sessionId: string, esignAskfieldsFormData: any) => {
    const baseURL = window.location.origin;
    console.log("esignAskfieldsFormData", esignAskfieldsFormData);
    if (esignAskfieldsFormData.length > 0){
    try {
        await axios.post(
            `${baseURL}/docsigning/info/inbox/fields/${msgID}?SessionID=${sessionId}`,
            { fields: esignAskfieldsFormData },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return true;
    } catch (error) {
        console.error("Error submitting form data:", error);
            return false;
        }
    }
};
const SaveButton = React.forwardRef((props: SaveButtonProps, ref) => {
    const dispatch = useDispatch();
    // const keyDateTasks = useAppSelector((state) => state.InFileTasks);
    const handler = useCallback(async () => {
        let DataReaderObj: RPWDataReader;
        let dRoot = (props.livedataRootContainer.dataRoot as any);
        if (dRoot) {
            DataReaderObj = getDataReader(dRoot);
            const staffEmail = DataReaderObj.getFirmIncludedEmail();
            const firmEmail = dRoot.getAttribute("FirmEmail");
            if (staffEmail && staffEmail !== firmEmail) {
                dRoot.setAttribute("FirmEmail", staffEmail);
            }
        }

        switch (props.screenType) {
            case ScreenType.InFile:
                // KeyDate.SaveKeyDates(getDataReader(props.livedataRootContainer.dataRoot), props.SESSION_INFO, keyDateTasks);
                saveFile(props.activityCenter.Add);
                break;
            case ScreenType.FirmSettings:
                runInnerFunction('UpdateLawyerProfileXML', null);
                break;
            case ScreenType.Packages:
                if (props.state.ListData.PackageList?.length > 0) {
                    try {
                        await updatePackageList(props.SESSION_INFO.appProvinceShort, props.SESSION_INFO.firm.id.toString(), props.SESSION_INFO.sid, props.state.ListData.PackageList)
                            .then((res) => {
                                if (res) {
                                    props.activityCenter.Add("Package List Saved Successfully", undefined, "save", null);
                                    props.dispatch(setListDataState("PackageList", []));
                                    props.dispatch(setIndicators("IsPageDirty", false));
                                    props.dispatch(setShowPackageSaveWarning(true));
                                    props.setIsDirty(false);
                                }
                            });
                    } catch (e) {
                        props.activityCenter.Add(`Error saving Package List ${e}.`, undefined, "error", null);
                        console.error(e);
                        break;
                    }
                }
                break;
        }
        if (props.page.reactFrame === "builderesign") {
            const DataReaderObj = getDataReader(props.livedataRootContainer.dataRoot);
            const msgID = DataReaderObj.getVIPInfoMsgID();
            const baseURL = window.location.origin;
            dispatch(setIndicators("IsPageDirty", false)) 
            try {
                await axios.post(
                    `${baseURL}/docsigning/info/inbox/fields/${msgID}?SessionID=${props.SESSION_INFO.sid}`,
                    { fields: props.esignAskfieldsFormData },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );
            } catch (error) {
              console.error("Error submitting form data:", error);
            } 
        }
    }, [props]);

    React.useImperativeHandle(ref, () => ({
        handleSave: handler,
    }));

    return (
        <>
            <div className={props.isDirty ? "tab tab-active-save" : "tab"}
                onClick={handler}>
                <i className={props.isDirty ? "fa-duotone fa-action fa-floppy-disk" : "fa-duotone fa-floppy-disk"}></i>
                <span>Save</span>
            </div>
        </>
    );
});

export const RightSideBar = (props: RightMenuItemPropType) => {
    const nav = useContext(NavigationContext);
    const activityCenter = useContext(ActivityCenterContext);
    const state: lddStateObject = store.getState();
    const appcode = state?.SessionInfo?.appCode;
    const screenType = props.page.params? props.page.params['formasp'] : props.page.reactFrame?? null;
    const isCollege = state?.SessionInfo?.firm?.IsCollege;
    const esignAskfieldsFormData = useSelector((state: RootState) => state.esignAskfieldsForm);
    var appointment: NavObjectType = {
        component: "main",
        url: "lfmaster.asp",
        params: {
            compat: "1",
            formasp: "appointment",
            id: CONST.uninitialized,
            src: "xml/public/NewLiveAppointmentapp.xml",
        },
        popup: true,
        isModal: true,
    };
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const sideMenuReload = useAppSelector((state: lddStateObject) => state.SideMenuReload);
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g) => g.SessionInfo);
    const [isDirty, setIsDirty] = useState<boolean>(false);
    const saveButtonRef = useRef(null);
    const dispatch = useDispatch();
    const SessionID = SESSION_INFO.sid;
    const AppCode = SESSION_INFO.appCode;
    const UserID = SESSION_INFO.firm.id;

    useEffect(() => {
        try {
            setIsDirty(runInnerFunction('CheckIsDirty', null));
        } catch (e) {
            
        }
    }, [sideMenuReload, livedataRootContainer])

    const Indicators = useAppSelector((g: lddStateObject) => g.Indicators);
    const RightSideValue = useContext(RightSideContext);
    useEffect(() => {
        if (Indicators.Activity && RightSideValue.rightSideBoolean && RightSideValue.rightSideShow === "Activity") {
            dispatch(setIndicators("Activity", false));
            dispatch({ type: ReducerEnum.SET_RESET_ACTIVITYCENTERUNREAD });
        }
        
        setIsDirty(Indicators.IsPageDirty?? false);
    }, [Indicators])

    const tabsDisplayStyle = () => {
        if (isPageInDR(props.page)) {
            return "hidden";
        }
        return "";
    }

    return (
        <nav className={`toolbar-tabs ${tabsDisplayStyle()}`} key={'right-side-nav'}>
            {Object.values(ScreenType).includes(screenType as ScreenType)  && 
                <SaveButton 
                    page={props.page}
                    screenType={screenType}
                    isDirty={isDirty}
                    setIsDirty={setIsDirty}
                    dispatch={dispatch}
                    livedataRootContainer={livedataRootContainer}
                    SESSION_INFO={SESSION_INFO}
                    state={state}
                    activityCenter={activityCenter}
                    ref={saveButtonRef}
                    esignAskfieldsFormData={esignAskfieldsFormData}
                />
            }

            {
                (screenType === ScreenType.InFile) && !isCollege && 
                <div className="tab renai-tab" onClick={() => { props.toggle('RenAI') }}>
                    <i className="fa-duotone fa-stars"></i>
                    <span>RenAI</span>
                </div>
            }

            {(screenType === ScreenType.InFile) &&
                <>
                    <div className="tab" onClick={() => props.toggle('KeyDates')}>
                        <i className="fa-duotone fa-list-check"></i>
                        <span>Tasks</span>
                    </div>
                </>
            }

            {(!isPageInDR(props.page) && SESSION_INFO?.appCode !== "DR") &&
                <div className="tab" onClick={() => { props.toggle('Activity') }}>
                    <i className="fa-duotone fa-check-double" ></i>
                    <span>Activity</span>
                    <i style={{ padding: "unset" }} className={`indicator indicator-warn ${Indicators.Activity ? "show" : ""}`} />
                </div>
            }
            {appcode === "RPWBC" && screenType != ScreenType.InFile &&
                <>
                    {/* <div className="tab" onClick={() => nav(OpenBCRegistration)}>
                        <i className="fa-duotone fa-registered"></i>
                        <span>Reg</span>
                    </div> */}
                    <div className="tab" onClick={() => nav(OpenBCTitleSearch)}>
                        <i className="fa-duotone fa-file-magnifying-glass"></i>
                        <span>Title</span>
                    </div>
                </>
            }

            {screenType === ScreenType.InFile &&
                <>
                    <div className="tab" onClick={() => props.toggle('Notes')}>
                        <i className="fa-duotone fa-notes"></i>
                        <span>Notes</span>
                    </div>
                    <div className="tab" onClick={() => nav(appointment)}>
                        <i className="fa-duotone fa-calendar-circle-plus" />
                        <span>App't</span>
                    </div>
                    {
                    !isCollege && 
                        <div className="tab" onClick={() => { runInnerFunction('SendEmailMain', null) }}>
                            <i className="fa-duotone fa-envelope"></i>
                            <span>Email</span>
                        </div>
                    }
                    <div className="tab" onClick={() => { props.toggle('History') }}>
                        <i className="fa-duotone fa-timeline" ></i>
                        <span >History</span>
                    </div>
                </>
            }


            {!isCollege && SESSION_INFO?.appCode && SESSION_INFO?.appCode !== "DR" && <div className="tab" onClick={() => { nav(OpenReports) }}>
                <i className="fa-duotone fa-chart-simple"></i>
                <span>Reports</span>
            </div>}

            {screenType === ScreenType.InFile && !isCollege && <DriveTab
                SessionID={SessionID}
                AppCode={AppCode}
                UserID={UserID}
                isCollege={isCollege}
            />}

            {(!isPageInDR(props.page) && SESSION_INFO?.appCode !== "DR") &&
                <div className="tab expand-collapse" onClick={() => props.toggle('toggle')}>
                    <i className={RightSideValue.rightSideBoolean ? "fa-duotone fa-circle-chevron-right" : "fa-duotone fa-circle-chevron-right rotate180"} style={{ paddingTop: "15px", paddingBottom:'13px' }}></i>
                </div>
            }
        </nav>   
    );
}

